import styled from 'styled-components'

import Link from '~/shared/assets/icons/Link'
import CircleDefaultImage from '~/shared/assets/images/CircleDefaultImage.png'
import theme from '~/shared/styles/theme'
import isValidURL from '~/shared/utils/isValidUrl'

interface Props {
  circleId: string
  thumbnailImgSrc: string
  title: string
  circleMaster: string
  circleLink: string
  hashtags: string[]
  zoneTypeDesc: string
  dateTypeDesc: string
}

function CircleItem({
  circleId,
  thumbnailImgSrc,
  title,
  circleMaster,
  circleLink,
  hashtags,
  zoneTypeDesc,
  dateTypeDesc,
}: Props) {
  return (
    <Wrapper
      target="_blank"
      href={`${import.meta.env.VITE_REDIRECT_URI}circle-participation/info/${circleId}`}
    >
      <CircleThumbnail
        alt="circle-thumbnail"
        src={thumbnailImgSrc || CircleDefaultImage}
      />
      <InfoBox>
        <CircleMainInfo>
          <div className="title">{title}</div>
          <div className="circle-master">대표자 닉네임: {circleMaster}</div>
          <div className="location">{zoneTypeDesc}</div>
          <div>{dateTypeDesc}</div>
        </CircleMainInfo>
        <CircleSubInfo>
          {circleLink && isValidURL(circleLink) && (
            <a className="circle-link" href={circleLink} target="_blank">
              서클 홍보링크 <Link />
            </a>
          )}

          <div className="hashtags">
            {hashtags.map((hashtag) => {
              return (
                <div key={hashtag} className="hashtag">
                  {hashtag}
                </div>
              )
            })}
          </div>
        </CircleSubInfo>
      </InfoBox>
    </Wrapper>
  )
}

export default CircleItem

const Wrapper = styled.a`
  cursor: pointer;

  overflow: hidden;
  display: flex;
  gap: 24px;
  align-items: center;

  box-sizing: border-box;
  width: 49%;
  min-height: 200px;
  padding: 20px;

  color: ${theme.colors.black};
  text-decoration: none;

  border: 1px solid #c1c3c2;
  border-radius: 12px;

  @media ${theme.device.medium} {
    align-items: start;
    width: 100%;
    height: auto;
    min-height: 234px;
  }
`

const CircleThumbnail = styled.img`
  width: 160px;
  height: 160px;
  border-radius: 12px;

  @media ${theme.device.medium} {
    width: 64px;
    height: 64px;
  }
`

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  justify-content: space-between;

  width: 304px;
  height: 160px;

  @media ${theme.device.medium} {
    height: 200px;
  }
`

const CircleMainInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  .title {
    width: 99%;
    margin-bottom: 8px;

    font-family: NanumSquareNeo-Bold, sans-serif;
    font-size: 21px;
    font-weight: 500;
    line-height: 24px;
    text-overflow: ellipsis;
    white-space: nowrap;

    -webkit-line-clamp: 1;

    @media ${theme.device.medium} {
      font-size: 18px;
    }
  }

  .location {
    width: 99%;

    font-family: NanumSquareNeo-Regular, sans-serif;
    font-size: 15px;
    line-height: 24px;
    text-overflow: ellipsis;
    white-space: nowrap;

    -webkit-line-clamp: 1;
  }

  .circle-master {
    width: 99%;

    font-family: NanumSquareNeo-Regular, sans-serif;
    font-size: 15px;
    line-height: 24px;
    text-overflow: ellipsis;
    white-space: nowrap;

    -webkit-line-clamp: 1;
  }
`

const CircleSubInfo = styled.div`
  .circle-link {
    display: flex;
    gap: 4px;
    align-items: center;

    width: 99%;

    font-family: NanumSquareNeo-Regular, sans-serif;
    font-size: 15px;
    font-weight: 400;
    line-height: 24px;
    color: ${theme.colors.mint_3};
    text-decoration: none;
    text-overflow: ellipsis;
    white-space: nowrap;

    -webkit-line-clamp: 1;
  }

  .hashtags {
    overflow: hidden;
    display: flex;
    flex-wrap: wrap;
    gap: 4px;

    width: 99%;
    height: 48px;

    text-overflow: ellipsis;
    white-space: nowrap;

    -webkit-line-clamp: 1;

    @media ${theme.device.medium} {
      overflow: visible;
    }
  }

  .hashtag {
    font-family: NanumSquareNeo-Regular, sans-serif;
    font-size: 15px;
    font-weight: 400;
    line-height: 24px;
    color: ${theme.colors.grey_4};
  }
`
